module.exports = __webpack_public_path__ + "static/media/ApplicationSent.d4c6d7c1.svg";